"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteStatus = void 0;
var InviteStatus;
(function (InviteStatus) {
    InviteStatus["PENDING"] = "PENDING";
    InviteStatus["ACCEPTED"] = "ACCEPTED";
    InviteStatus["REVOKED"] = "REVOKED";
    InviteStatus["EXPIRED"] = "EXPIRED";
})(InviteStatus || (exports.InviteStatus = InviteStatus = {}));
